/**
 * Fixed SRP map-view dimensions used for computing listings-query bounds.
 *
 * Both the server (fetchers.ts) and the client (MapStateHydrator,
 * LiveListingsGrid) use these exact values so the `searchKeys.listings` query
 * key produced on initial render stays stable from SSR through hydration —
 * otherwise the client would refetch on mount with slightly different bounds.
 *
 * The actual map viewport still fits its own container via Google Maps'
 * fitBounds; these values only influence the bounds computation used as the
 * listings query input.
 */
export const SRP_LISTINGS_VIEW = {
  width: 800,

  height: 600,

  padding: 60,
} as const;
